"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ClipboardUser: function() {
        return ClipboardUser;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ClipboardUser = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.79289 1.79289C8.30057 1.28521 8.98914 1 9.70711 1H14.2929C15.0109 1 15.6994 1.28521 16.2071 1.79289C16.5444 2.13022 16.7835 2.5474 16.906 3H18C19.6569 3 21 4.34315 21 6V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V6C3 4.34315 4.34315 3 6 3H7.09397C7.21646 2.5474 7.45557 2.13022 7.79289 1.79289ZM7 5H6C5.44772 5 5 5.44772 5 6V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V6C19 5.44772 18.5523 5 18 5H17V6C17 6.55228 16.5523 7 16 7H8C7.44772 7 7 6.55228 7 6V5ZM14.7929 3.20711C14.6603 3.0745 14.4804 3 14.2929 3H9.70711C9.51957 3 9.33972 3.0745 9.20711 3.20711C9.0745 3.33972 9 3.51957 9 3.70711V4V5H15V4V3.70711C15 3.51957 14.9255 3.33972 14.7929 3.20711ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM12.0002 17C11.1309 17 10.3888 17.5551 10.1137 18.3332C9.92969 18.854 9.35837 19.1269 8.83765 18.9428C8.31694 18.7588 8.04401 18.1875 8.22806 17.6668C8.7767 16.1145 10.257 15 12.0002 15C13.7434 15 15.2237 16.1145 15.7723 17.6668C15.9564 18.1875 15.6834 18.7588 15.1627 18.9428C14.642 19.1269 14.0707 18.854 13.8866 18.3332C13.6116 17.5551 12.8694 17 12.0002 17Z",
        fill: "currentColor"
    })
}), "ClipboardUser");
const _default = ClipboardUser;
